import { ref, onMounted, watch, nextTick } from 'vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/chat/chatList/pdf.png';
const _withScopeId = n => (_pushScopeId("data-v-bbc1d7c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chatlist_container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "shade"
}, null, -1));
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  key: 2,
  class: "item item_text_jump"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://paint.weta365.com/"
}, "https://paint.weta365.com/", -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 3,
  class: "item item_img"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "",
  alt: ""
}, null, -1));
const _hoisted_10 = {
  class: "btn-download"
};
const _hoisted_11 = {
  key: 4,
  class: "item item_video"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  src: ""
}, null, -1));
const _hoisted_13 = {
  class: "btn-download"
};
const _hoisted_14 = {
  key: 5,
  class: "item item_collect"
};
const _hoisted_15 = {
  key: 7,
  class: "item item_file"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_type"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_17 = {
  class: "info"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "file_name ellipsis-3"
}, " 我是文件名.pdf ", -1));
const _hoisted_19 = {
  class: "bottom"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "file_size"
}, "16.8 KB", -1));
import SelectVoice from './selectVoice.vue';
import bus from '@/utils/mitt.js';
import LottieView from '@/components/lottieView.vue';
import lottieJson from '../../../../public/animationData/chat/loading.json';
import userHooks from '@/hooks/userHooks';
import { saveChatMessage, getMacChatMessageWithUuid } from '@/api/chat';
import roleHooks from '@/hooks/roleHooks';
import LikeSet from './likeSet.vue';
import { getProjectStatusList } from '@/api/chat';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      macId,
      getMacId,
      getMessageTotalInfo,
      uuid
    } = userHooks();
    const {
      curSelectRoleInfo,
      showAvatar
    } = roleHooks();
    const chatList = ref([]);
    const chatref = ref(null);
    onMounted(() => {
      bus.on('chatmessage', dellChat);
      bus.on('stopChat', stopChat);
      getStatusList();
    });
    watch(curSelectRoleInfo, () => {
      chatList.value = [];
    });
    const dellChat = data => {
      updateChatList(data);
      scrollBottom();
    };
    const stopChat = () => {
      streamText.value = '';
      const data = chatList.value[chatList.value.length - 1];
      if (data.content) {
        saveChat({
          ...data,
          done: true
        }, data);
      } else {
        chatList.value.pop();
      }
    };
    const saveChat = async (data, oriData) => {
      if (data.type == 'right' || data.type == 'left' && data.done) {
        if (data.content) {
          const id = await saveChatMessage({
            macId: macId.value,
            content: data.content,
            roleId: curSelectRoleInfo.value.id,
            type: data.type == 'right' ? 1 : 2,
            session: uuid.value
          });
          oriData.id = id;
        }
      }
    };
    const stream = ref();
    const streamText = ref('');
    const updateChatList = data => {
      if (data.type == 'left') {
        if (data.done == -1) {
          chatList.value.pop();
          return;
        }
        streamText.value += data.content;
        chatList.value[chatList.value.length - 1] = {
          ...data,
          content: streamText.value
        };
        if (data.done) {
          saveChat({
            ...data,
            content: streamText.value
          }, chatList.value[chatList.value.length - 1]);
          streamText.value = '';
        }
      } else {
        chatList.value.push(data);
        chatList.value.push({
          type: 'left'
        });
        saveChat(data, data);
      }
    };
    const getChatMessageList = async () => {
      // return
      const res = await getMacChatMessageWithUuid({
        macId: macId.value,
        roleId: curSelectRoleInfo.value.id,
        sort: 'asc',
        uuid: uuid.value,
        page: 1,
        limit: 10000
      });
      chatList.value = res.map(vo => {
        return {
          ...vo,
          type: vo.type == 1 ? 'right' : 'left'
        };
      });
      scrollBottom();
    };
    watch([curSelectRoleInfo, uuid], newval => {
      if (newval) {
        getChatMessageList();
      }
    });
    watch(chatList.value, () => {
      scrollBottom();
    }, {
      deep: true
    });
    const scrollBottom = () => {
      nextTick(() => {
        chatref.value.scrollTop = chatref.value.scrollHeight;
      });
    };
    const statusList = ref([]);
    const getStatusList = async () => {
      statusList.value = await getProjectStatusList({});
    };
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        class: _normalizeClass(["scrolldiv", {
          scrolldivtype3: _ctx.$route.query.type == 'show'
        }]),
        ref_key: "chatref",
        ref: chatref
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatList), (vo, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [vo.content ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["item item_text", {
            item_left: vo.type == 'left',
            item_left_avatar: vo.type == 'left' && !_unref(showAvatar),
            item_right: vo.type == 'right',
            item_right_avatar: vo.type == 'right' && !_unref(showAvatar)
          }])
        }, [_createElementVNode("div", {
          class: "content",
          innerHTML: vo.content
        }, null, 8, _hoisted_3), vo.type == 'left' && vo.id ? (_openBlock(), _createBlock(LikeSet, {
          key: 0,
          statusList: _unref(statusList),
          item: vo,
          class: "opt"
        }, null, 8, ["statusList", "item"])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), !vo.content && index == _unref(chatList).length - 1 ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["item item_loading item_left", {
            item_left_avatar: !_unref(showAvatar)
          }])
        }, [_createElementVNode("div", _hoisted_4, [_createVNode(LottieView, {
          id: 'chat' + index,
          class: "chat_loading",
          autoplay: true,
          loop: true,
          jsonData: _unref(lottieJson),
          assetsPath: "/animationData/chat/"
        }, null, 8, ["id", "jsonData"])])], 2)) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "下载",
          placement: "right"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_svg_icon, {
            class: "icon",
            iconClass: "download"
          })])]),
          _: 1
        })])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "下载",
          placement: "right"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_svg_icon, {
            class: "icon",
            iconClass: "download"
          })])]),
          _: 1
        })])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_14)) : _createCommentVNode("", true), false ? (_openBlock(), _createBlock(SelectVoice, {
          key: 6,
          class: "item"
        })) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_svg_icon, {
          class: "icon-download",
          iconClass: "start"
        }), _createVNode(_component_svg_icon, {
          class: "icon-download",
          iconClass: "download"
        })])])])) : _createCommentVNode("", true)], 64);
      }), 128))], 2)]);
    };
  }
});